function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/image/imageblockediting
 */
import { Plugin } from 'ckeditor5/src/core';
import { ClipboardPipeline } from 'ckeditor5/src/clipboard';
import { UpcastWriter } from 'ckeditor5/src/engine';
import { modelToViewAttributeConverter, srcsetAttributeConverter, viewFigureToModel } from './converters';
import ImageEditing from './imageediting';
import ImageTypeCommand from './imagetypecommand';
import ImageUtils from '../imageutils';
import { getImageTypeMatcher, createImageViewElement, determineImageTypeForInsertionAtSelection } from '../image/utils';
/**
 * The image block plugin.
 *
 * It registers:
 *
 * * `<imageBlock>` as a block element in the document schema, and allows `alt`, `src` and `srcset` attributes.
 * * converters for editing and data pipelines.,
 * * {@link module:image/image/imagetypecommand~ImageTypeCommand `'imageTypeBlock'`} command that converts inline images into
 * block images.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageBlockEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(ImageBlockEditing, _Plugin);

  var _super = _createSuper(ImageBlockEditing);

  function ImageBlockEditing() {
    _classCallCheck(this, ImageBlockEditing);

    return _super.apply(this, arguments);
  }

  _createClass(ImageBlockEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      var schema = editor.model.schema; // Converters 'alt' and 'srcset' are added in 'ImageEditing' plugin.

      schema.register('imageBlock', {
        isObject: true,
        isBlock: true,
        allowWhere: '$block',
        allowAttributes: ['alt', 'src', 'srcset']
      });

      this._setupConversion();

      if (editor.plugins.has('ImageInlineEditing')) {
        editor.commands.add('imageTypeBlock', new ImageTypeCommand(this.editor, 'imageBlock'));

        this._setupClipboardIntegration();
      }
    }
    /**
     * Configures conversion pipelines to support upcasting and downcasting
     * block images (block image widgets) and their attributes.
     *
     * @private
     */

  }, {
    key: "_setupConversion",
    value: function _setupConversion() {
      var editor = this.editor;
      var t = editor.t;
      var conversion = editor.conversion;
      var imageUtils = editor.plugins.get('ImageUtils');
      conversion.for('dataDowncast').elementToElement({
        model: 'imageBlock',
        view: function view(modelElement, _ref) {
          var writer = _ref.writer;
          return createImageViewElement(writer, 'imageBlock');
        }
      });
      conversion.for('editingDowncast').elementToElement({
        model: 'imageBlock',
        view: function view(modelElement, _ref2) {
          var writer = _ref2.writer;
          return imageUtils.toImageWidget(createImageViewElement(writer, 'imageBlock'), writer, t('image widget'));
        }
      });
      conversion.for('downcast').add(modelToViewAttributeConverter(imageUtils, 'imageBlock', 'src')).add(modelToViewAttributeConverter(imageUtils, 'imageBlock', 'alt')).add(srcsetAttributeConverter(imageUtils, 'imageBlock')); // More image related upcasts are in 'ImageEditing' plugin.

      conversion.for('upcast').elementToElement({
        view: getImageTypeMatcher(editor, 'imageBlock'),
        model: function model(viewImage, _ref3) {
          var writer = _ref3.writer;
          return writer.createElement('imageBlock', {
            src: viewImage.getAttribute('src')
          });
        }
      }).add(viewFigureToModel(imageUtils));
    }
    /**
     * Integrates the plugin with the clipboard pipeline.
     *
     * Idea is that the feature should recognize the user's intent when an **inline** image is
     * pasted or dropped. If such an image is pasted/dropped:
     *
     * * into an empty block (e.g. an empty paragraph),
     * * on another object (e.g. some block widget).
     *
     * it gets converted into a block image on the fly. We assume this is the user's intent
     * if they decided to put their image there.
     *
     * See the `ImageInlineEditing` for the similar integration that works in the opposite direction.
     *
     * @private
     */

  }, {
    key: "_setupClipboardIntegration",
    value: function _setupClipboardIntegration() {
      var editor = this.editor;
      var model = editor.model;
      var editingView = editor.editing.view;
      var imageUtils = editor.plugins.get('ImageUtils');
      this.listenTo(editor.plugins.get('ClipboardPipeline'), 'inputTransformation', function (evt, data) {
        var docFragmentChildren = Array.from(data.content.getChildren());
        var modelRange; // Make sure only <img> elements are dropped or pasted. Otherwise, if there some other HTML
        // mixed up, this should be handled as a regular paste.

        if (!docFragmentChildren.every(imageUtils.isInlineImageView)) {
          return;
        } // When drag and dropping, data.targetRanges specifies where to drop because
        // this is usually a different place than the current model selection (the user
        // uses a drop marker to specify the drop location).


        if (data.targetRanges) {
          modelRange = editor.editing.mapper.toModelRange(data.targetRanges[0]);
        } // Pasting, however, always occurs at the current model selection.
        else {
            modelRange = model.document.selection.getFirstRange();
          }

        var selection = model.createSelection(modelRange); // Convert inline images into block images only when the currently selected block is empty
        // (e.g. an empty paragraph) or some object is selected (to replace it).

        if (determineImageTypeForInsertionAtSelection(model.schema, selection) === 'imageBlock') {
          var writer = new UpcastWriter(editingView.document); // Wrap <img ... /> -> <figure class="image"><img .../></figure>

          var blockViewImages = docFragmentChildren.map(function (inlineViewImage) {
            return writer.createElement('figure', {
              class: 'image'
            }, inlineViewImage);
          });
          data.content = writer.createDocumentFragment(blockViewImages);
        }
      });
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [ImageEditing, ImageUtils, ClipboardPipeline];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'ImageBlockEditing';
    }
  }]);

  return ImageBlockEditing;
}(Plugin);

export { ImageBlockEditing as default };